<template>
  <div class="product-card" @click="$emit('click')">
    <div class="stock-card_img mx-2 mt-2" v-if="itemImage">
      <img :src="itemImage" alt="Item Image" loading="lazy" decoding="async">
    </div>
    <div class="card-body mx-3 p-1 d-flex justify-content-between flex-column">
<!--      <span class="text-secondary text-sm">Stock Code : {{ product.PLU }}</span>-->
      <h6 class="product-description">
        {{ description }} <br>
        <span v-show="showQty">
          <span v-if="product.QTY > 0" class="badge bg-info">Qty in Stock : {{ $utils.formatQTY(product.QTY) }}</span>
          <span v-else-if="product.StockSetting.NonStock" class="badge bg-info">Service</span>
          <span v-else class="badge bg-danger">Not in Stock</span>
        </span><br>
        <span class="product-description2">{{ description2 }}</span>
      </h6>
      <h5 class="product-price">{{ $utils.formatMoney(product.SellingIncl) }}</h5>
    </div>
  </div>
</template>

<script>
import { utils as $utils } from "@/utils/utils";

export default {
  name: "ProductItem",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    description() {
      return $utils.toPascalCase(this.product.Description);
    },
    description2() {
      return $utils.toPascalCase(this.product.Description2);
    },
    showQty() {
      let securities = this.$store.getters.getSecurities;
      if (!securities) return false;
      return !securities.hideQuantity;
    },
    itemImage() {
      return this.product.Image
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      textLength: 50,
      image: require('@/assets/img/no-image.png')
    };
  },
  watch: {
    windowWidth(nh, oh) {
      if (nh < 400) {
        this.textLength = 25;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h4, h5, h6 {
  margin: 0;
}

.example-card-img-responsive {
  width: 80px;
  height: 65px;
  margin: 10px;
  opacity: 0.8;
}

.product-card {
  height: 110px;
  transition: 200ms ease-in-out;
  overflow: hidden;
  width: 100%;
  word-wrap: break-word;
  background-color: var(--card-bg);
  background-clip: border-box;
  border: var(--card-border);
  border-radius: var(--card-radius);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  .product-description {
    font-weight: 600;
    color: var(--text-primary);
  }

  .product-description2 {
    font-weight: 400;
    color: var(--text-secondary);
  }

  .product-price {
    font-weight: 700;
    color: var(--text-primary);
  }

  &:hover, &:focus {
    background: var(--accent-primary);
    color: white;
    transform: var(--hover-scale);

    .product-description {
      color: white;
    }

    .product-price {
      color: white;
    }
  }
}

img {
  height: 94px;
  width: 94px;
  opacity: 0.7;
  border-radius: 10px;
}

.text-sm {
  font-size: 12px !important;
}
</style>
